export default "__VITE_ASSET__EVRaC6I9__"